/**
 * Popover offset from `DropdownMenuContent` — base gap (~2px) plus 10px downward adjustment for the shell avatar trigger.
 */
export const PROFILE_MENU_POPOVER_OFFSET_PX = 12;

/**
 * Width and corner radius for profile menu `DropdownMenuContent` on **desktop** anchored popovers only.
 * Omit on phone so CUI can use the full-width bottom-sheet menu without mf-publisher width locks.
 */
export const profileDropdownMenuSurfaceCss = "p1cj5ss8";

require("./profileMenuDropdownChrome.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./profileMenuDropdownChrome.ts");